import create from 'zustand'
import { priceConcernAdminService } from '../services'

/**
 * Nav badge for Not reviewed count (from backend summary, not table page).
 */
const usePriceConcernBadgeStore = create((set) => ({
  notReviewedCount: 0,
  setNotReviewedCount: (n) =>
    set({ notReviewedCount: Math.max(0, Number(n) || 0) }),
  refresh: async () => {
    try {
      const data = await priceConcernAdminService.summary({})
      set({ notReviewedCount: Math.max(0, Number(data?.notReviewedCount) || 0) })
    } catch {
      // Keep last known count; badge is best-effort.
    }
  },
}))

export default usePriceConcernBadgeStore
